import React, { useCallback, useEffect, useState } from "react";

import {
  Button,
  FormControlLabel,
  Radio,
  RadioGroup,
  Stack,
} from "@mui/material";
import { Typography, Grid, FormControl } from "@material-ui/core";

import "assets/css/together/togetherSchedule.scss";
import { useRadioGroup } from "common/hooks";
import { useCommonQuery } from "common/hooks";
import { useApiContext } from "common/context";
import moment from "moment";

function TogetherScheduleTable({
  orderInfo,
  together,
  setLectureSeq,
  setAsisStudyRoomSeq,
  setTobeStudyRoomSeq,
  changeScheduleType,
  scheduleStatus = null,
  superpot,
  setSuperpotSchedule,
}) {
  const { queries } = useApiContext();
  const dayScheduleSelect = useRadioGroup(
    together.hourCode ? together.hourCode : "",
  );
  const [applyDaySelect, setDaySelect] = useState(
    together.dayCode ? together.dayCode : "",
  );
  const [changeScheduleList, setChangeScheduleList] = useState([]);
  const isTodaySchdule = together.scheduleDate
    ? together.isTodayStudyYn
    : moment(together.scheduleDate).isSame(moment(), "day");

  // 2024-06-13 스케줄 데이터 당일 수업 1시간전까지 당일 변경가능추가
  const { request: requestChangeableTogetherSchedule } = useCommonQuery({
    query: queries.togetherChangeSchedules,
    params: {
      lep_order_no: orderInfo.lep_order_no,
      study_day:
        isTodaySchdule && scheduleStatus == 1
          ? moment().format("YYYYMMDD")
          : together.nextLessonDate, // 당일 수업 1시간 전
      school_day_code: applyDaySelect,
      member_code: orderInfo.bookclub_child_member_code_choose, // bookclub_child_member_code
      change_type: changeScheduleType,
      lep_vbeln: together.vbeln
        ? together.vbeln
        : orderInfo.bookclub_contract_number_choose,
    },
    callbacks: {
      onSuccess: (data) => {
        if (data.result_code === "0000") {
          if (data.result_data.resultCode === "200") {
            setChangeScheduleList(
              data.result_data.data.scheduleChangeAbleList.dataList,
            );
            setLectureSeq(
              data.result_data.data.scheduleChangeAbleList.lectureSeq,
            );
            setAsisStudyRoomSeq(
              data.result_data.data.scheduleChangeAbleList.asisStudyRoomSeq,
            );
          } else {
            return;
          }
        } else {
          console.log("togetherChangeSchedules Error ::", data.result_message);
          // showAlert('알림', data.result_message);
        }
      },
      onError: (error) => {
        console.log("togetherChangeSchedules Error ::", error);
        // showAlert('알림', '스케줄 조회에 실패했습니다.');
      },
    },
    initEnabled: false,
  });

  const { request: requestChangableSuperpotSchedule } = useCommonQuery({
    query: queries.superChangeableSchedule,
    params: {
      progressSeq: superpot?.progressSeq,
      studyMonth: moment(superpot?.scheduleDate).format("YYYYMM"),
      studyDegree: superpot?.studyDegree,
      dayCode: applyDaySelect,
      courseType: orderInfo.together_course_code || together.courseCode,
    },
    callbacks: {
      onSuccess: (data) => {
        if (data.result_code === "0000") {
          setChangeScheduleList(data.result_data);
        } else {
          showAlert("알림", data.result_message);
        }
      },
      onError: (error) => {
        console.log(error);
      },
    },
    initEnabled: false,
  });

  // applyDaySelect가 변경될 때 스케줄 API 호출
  useEffect(() => {
    if (applyDaySelect && orderInfo.lep_order_no && !superpot) {
      requestChangeableTogetherSchedule();
    } else if (
      (together?.courseCode === "CT01" ||
        together?.courseCode === "CT02" ||
        orderInfo?.together_course_code === "CT01" ||
        orderInfo?.together_course_code === "CT02") &&
      superpot &&
      applyDaySelect
    ) {
      requestChangableSuperpotSchedule();
    }
  }, [applyDaySelect]);

  const changeApplyDaySelect = useCallback(
    (day) => {
      if (!day || applyDaySelect == day) {
        return;
      }
      setDaySelect(day);
      dayScheduleSelect.update(-1);
    },
    [applyDaySelect],
  );

  const changeApplyTimeSelect = useCallback(
    (e) => {
      dayScheduleSelect.handleChange(e);
      dayScheduleSelect.update(e.target.value);

      // superpot인 경우 스케줄 저장
      if (
        together?.courseCode === "CT01" ||
        together?.courseCode === "CT02" ||
        orderInfo?.together_course_code === "CT01" ||
        orderInfo?.together_course_code === "CT02"
      ) {
        const selectedSchedule = changeScheduleList.find(
          (item) => item.classroomSeq == e.target.value,
        );
        if (selectedSchedule) {
          setSuperpotSchedule({
            ...selectedSchedule,
            dayCode: applyDaySelect,
          });
        }
      } else {
        setTobeStudyRoomSeq(e.target.value);
      }
    },
    [
      dayScheduleSelect.state,
      applyDaySelect,
      setTobeStudyRoomSeq,
      changeScheduleList,
      together?.courseCode,
      setSuperpotSchedule,
    ],
  );

  // useEffect를 제거하고 changeApplyTimeSelect에서 직접 처리하도록 변경
  // useEffect(() => {
  //   if (together?.courseCode === "CT01" || together?.courseCode === "CT02") {
  //     setSuperpotSchedule(
  //       changeScheduleList.find(
  //         (item) => item.classroomSeq == dayScheduleSelect.state,
  //       ),
  //     );
  //   }
  // }, [dayScheduleSelect.state]);

  return (
    <div className="schedule-wrap">
      <Typography className="wrap-title">
        수업 주차/일정을 선택해 주세요.
      </Typography>
      <Typography className="notice">
        <>
          <p>※ 실제 수업일을 꼭 확인해 주세요.</p>
          <p>
            ※ 선택한 수업 주차에 <span>공휴일</span>이 있을 시, 실제 수업 요일에
            차이가 발생될 수 있습니다.
          </p>
          {changeScheduleType === "A" && (
            <p>※ 모든 수업 일정 변경 시 1회 변경한 스케줄이 취소됩니다.</p>
          )}
        </>
      </Typography>

      <Stack direction="row" spacing={1} className="day-btn-area">
        <Button
          className={applyDaySelect == "DAY2" ? "active" : ""}
          variant="outlined"
          onClick={() => {
            changeApplyDaySelect("DAY2");
          }}
        >
          월요일
        </Button>
        <Button
          className={applyDaySelect == "DAY3" ? "active" : ""}
          variant="outlined"
          onClick={() => {
            changeApplyDaySelect("DAY3");
          }}
        >
          화요일
        </Button>
        <Button
          className={applyDaySelect == "DAY4" ? "active" : ""}
          variant="outlined"
          onClick={() => {
            changeApplyDaySelect("DAY4");
          }}
        >
          수요일
        </Button>
        <Button
          className={applyDaySelect == "DAY5" ? "active" : ""}
          variant="outlined"
          onClick={() => {
            changeApplyDaySelect("DAY5");
          }}
        >
          목요일
        </Button>
        <Button
          className={applyDaySelect == "DAY6" ? "active" : ""}
          variant="outlined"
          onClick={() => {
            changeApplyDaySelect("DAY6");
          }}
        >
          금요일
        </Button>
      </Stack>

      {applyDaySelect !== "" && (
        <Grid className="slt-area">
          <Stack direction="row" className="thead">
            <div className="cell">선택</div>
            <div className="cell">실제 수업일</div>
            <div className="cell">시간표</div>
            <div className="cell">신청</div>
          </Stack>
          <Stack direction="column" className="tbody">
            <FormControl>
              <RadioGroup
                name="scheduleTime"
                value={dayScheduleSelect.state}
                onChange={(e) => changeApplyTimeSelect(e)}
              >
                {changeScheduleList && changeScheduleList.length > 0 ? (
                  changeScheduleList?.map((item, idx) => (
                    <FormControlLabel
                      key={idx}
                      className={`${dayScheduleSelect.state != -1 && (together?.courseCode === "CT01" || together?.courseCode === "CT02" ? item.classroomSeq == dayScheduleSelect.state : item.STUDY_ROOM_SEQ == dayScheduleSelect.state) ? "isChecked" : ""}`}
                      value={
                        together?.courseCode === "CT01" ||
                        together?.courseCode === "CT02" ||
                        orderInfo?.together_course_code === "CT01" ||
                        orderInfo?.together_course_code === "CT02"
                          ? item.classroomSeq
                          : item.STUDY_ROOM_SEQ
                      }
                      control={<Radio />}
                      checked={
                        together?.courseCode === "CT01" ||
                        together?.courseCode === "CT02" ||
                        orderInfo?.together_course_code === "CT01" ||
                        orderInfo?.together_course_code === "CT02"
                          ? dayScheduleSelect.state != -1 &&
                            item.classroomSeq == dayScheduleSelect.state
                          : dayScheduleSelect.state != -1 &&
                            item.STUDY_ROOM_SEQ == dayScheduleSelect.state
                      }
                      label={
                        <>
                          <div className="cell">
                            {together?.courseCode === "CT01" ||
                            together?.courseCode === "CT02" ||
                            orderInfo?.together_course_code === "CT01" ||
                            orderInfo?.together_course_code === "CT02"
                              ? moment(item.toScheduleDate).format("MM/DD (dd)")
                              : moment(item.BASE_DATE).format("MM/DD (dd)")}
                          </div>
                          <div className="cell">
                            {together?.courseCode === "CT01" ||
                            together?.courseCode === "CT02" ||
                            orderInfo?.together_course_code === "CT01" ||
                            orderInfo?.together_course_code === "CT02"
                              ? item.note
                              : item.STUDY_ROOM_INFO}
                          </div>
                          <div className="cell">{"가능"}</div>
                        </>
                      }
                    />
                  ))
                ) : (
                  <div
                    style={{
                      textAlign: "center",
                      margin: "50px 0",
                      fontWeight: "bold",
                      color: "#1c1c1c",
                    }}
                  >
                    변경 가능한 일정이 없습니다.
                  </div>
                )}
              </RadioGroup>
            </FormControl>
          </Stack>
        </Grid>
      )}
    </div>
  );
}

export default React.memo(TogetherScheduleTable);
